export const FENDER_DIGITAL_JIRA_BROWSE_BASE = "https://fenderdigital.atlassian.net/browse/";

/** Typical Jira issue key, e.g. PRS-2333 */
const JIRA_ISSUE_KEY_PATTERN = /^[A-Z][A-Z0-9_]*-\d+$/;

export function normalizeJiraIssueKey(key: string): string {
  return key.trim().toUpperCase();
}

export function isValidJiraIssueKey(key: string): boolean {
  return JIRA_ISSUE_KEY_PATTERN.test(normalizeJiraIssueKey(key));
}

export function jiraBrowseUrlFromTicketKey(key: string | null | undefined): string | null {
  const normalized = normalizeJiraIssueKey(key ?? "");
  if (!normalized) return null;
  return `${FENDER_DIGITAL_JIRA_BROWSE_BASE}${normalized}`;
}
